<template>
  <div class="cards-wrapper">
    <div class="spinner-container" v-if="isLoading">
      <base-spinner
        :is-loading="true"
        :is-local="true"
        class="spinner"
      />
    </div>
    <div class="cards-container" v-if="!isLoading">
      <div class="main-card-container">
        <div class="main-card-title-block">
          <div class="main-card-title">
            {{ $t('message.cardsPage.mainCardTitle') }}
          </div>
          <button type="button" @click="addNewCard()" class="add-btn" v-if="isCardsListEmpty">
            <img src="/custom/images/plus-green.svg" alt="Plus">
            <span>{{ $t('message.cardsPage.addCardBtn') }}</span>
          </button>
        </div>

        <div class="empty-container" v-if="isCardsListEmpty">
          <img src="/custom/images/no-rate.svg" alt="Attention">
          <span>{{ $t('message.cardsPage.amountNotice') }}</span>
        </div>

        <div class="cards-block">
          <card
            v-if="mainCard"
            :key="mainCard.id"
            :data="mainCard"
            :defaultCardId="profile.default_card_id"
            @deleteCard="openDeleteCardModal"
          />
        </div>
      </div>

      <div class="secondary-card-container" v-if="!isCardsListEmpty">
        <div class="secondary-card-title-block">
          <div class="secondary-card-title">
            {{ $t('message.cardsPage.secondaryCardTitle') }}
          </div>
          <button @click="addNewCard()" class="add-btn" type="button">
            <img src="/custom/images/plus-green.svg" alt="Plus">
            <span>{{ $t('message.cardsPage.addCardBtn') }}</span>
          </button>
        </div>

        <div class="cards-block">
          <card
            v-for="item of secondaryCards"
            :key="item.id"
            :data="item"
            :defaultCardId="profile.default_card_id"
            @deleteCard="openDeleteCardModal"
            @setDefaultCard="openSetDefaultCardModal"
          />
        </div>
      </div>
    </div>
    <base-modal
      v-if="isShowSetDefaultCardModal"
      @close="closeSetDefaultCardModal()"
    >
      <template #main>
        <div class="change-default-card-modal">
          <div class="modal-header">
            <img @click.stop="closeSetDefaultCardModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
          </div>
          <div class="change-default-card-modal-icon">!</div>
          <div class="change-default-card-modal-title">
            {{ $t('message.cardsPage.changeDefaultCard.title') }}
          </div>
          <div class="change-default-card-modal-text">
            {{ $t('message.cardsPage.changeDefaultCard.textStart') }}
            <span>{{ selectedDefaultCardPan }}</span>
            {{ $t('message.cardsPage.changeDefaultCard.textEnd') }}
          </div>
          <div class="change-default-card-modal-btn-container">
            <base-button
              :text="$t('message.cardsPage.changeDefaultCard.confirmBtn')"
              :min-height="'40px'"
              :disabled="isSetDefaultCardLoading"
              :is-loading="isSetDefaultCardLoading"
              @click="confirmSetDefaultCard()"
            />
          </div>
        </div>
      </template>
    </base-modal>
    <base-modal
      v-if="isShowDeleteCardModal"
      @close="closeDeleteCardModal()"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeDeleteCardModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="notice-title">
          {{ $t('message.cardsPage.deleteCard.title') }}
        </div>
        <div class="notice-text">
          {{ $t('message.cardsPage.deleteCard.text') }}
        </div>
        <div class="modal-desc">
          {{ $t('message.cardsPage.deleteCard.desc') }}
        </div>
        <div class="btns-block">
          <div class="accept-btn-block">
            <base-button
              :text="$t('message.cardsPage.deleteCard.acceptBtn')"
              class="accept-btn"
              @click="deleteCard()"
            />
          </div>
          <div class="cancel-btn-block">
            <base-button
              :text="$t('message.cardsPage.deleteCard.closeBtn')"
              class="cancel-btn"
              @click="closeDeleteCardModal()"
            />
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';
import BaseSpinner from '../../components/base/BaseSpinner.vue';
import Card from './Card.vue';
import { mapGetters } from 'vuex';
import BaseModal from '../../components/base/BaseModal.vue';

export default {
  name: 'Cards',
  inject: ['$httpService'],
  components: {
    BaseButton,
    BaseSpinner,
    Card,
    BaseModal
  },
  async created() {
    

    const { uid, status } = this.$route.query;
    if (status === 'successful' && uid) {
      try {
        let resp = await this.$httpService.card.bindCard(uid);
        console.log(resp);
        
        this.$toast.success(this.$t('message.cardsPage.addCardSuccess'));
      } catch (error) {
        this.$toast.error(this.$t('message.cardsPage.addCardError'));
      }
    } else if (status === 'error' || status === 'failed') {
      this.$toast.error(this.$t('message.cardsPage.addCardError'));
    }

    try {
      await this.$store.dispatch('getCardsList');

      if (this.cardsList.length === 1) {
        if (this.cardsList[0].id !== this.profile.default_card_id) {
          await this.$store.dispatch('setDefaultCard', this.cardsList[0].id);
        }
      }
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: true,
      isAddBtnLoading: false,
      isShowDeleteCardModal: false,
      isShowSetDefaultCardModal: false,
      isSetDefaultCardLoading: false,
      deleteCardId: '',
      selectedDefaultCard: null
    }
  },
  methods: {
    async addNewCard() {
      this.isLoading = true;
      const returnUrl = window.location.href;
      const lang = this.$i18n.locale;
      const type = 'card_page';
      const stateInProgress = 'no';

      const payload = {returnUrl, lang, type, stateInProgress};

      try {
        const response = await this.$httpService.card.addNewCard(payload);
        window.location.href = response.data.redirect_url;
      } catch (error) {
        this.isLoading = false;
      }
    },
    openDeleteCardModal(card_id) {
      this.deleteCardId = card_id;
      this.isShowDeleteCardModal = true;
    },
    openSetDefaultCardModal(card) {
      this.selectedDefaultCard = card;
      this.isShowSetDefaultCardModal = true;
    },
    closeSetDefaultCardModal() {
      if (this.isSetDefaultCardLoading) {
        return;
      }
      this.selectedDefaultCard = null;
      this.isShowSetDefaultCardModal = false;
    },
    async confirmSetDefaultCard() {
      if (!this.selectedDefaultCard || this.isSetDefaultCardLoading) {
        return;
      }
      this.isSetDefaultCardLoading = true;
      try {
        await this.$store.dispatch('setDefaultCard', this.selectedDefaultCard.id);
        this.selectedDefaultCard = null;
        this.isShowSetDefaultCardModal = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.isSetDefaultCardLoading = false;
      }
    },
    closeDeleteCardModal() {
      this.deleteCardId = '';
      this.isShowDeleteCardModal = false;
    },
    async deleteCard() {
      this.isShowDeleteCardModal = false;
      this.isLoading = true;
      try {
        await this.$httpService.card.deleteCard(this.deleteCardId);
        await this.$store.dispatch('getCardsList');
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters(['cardsList', 'profile']),
    isCardsListEmpty() {
      return this.cardsList.length === 0;
    },
    mainCard() {
      const defId = this.profile?.default_card_id;
      if (!defId) {
        return null;
      }
      return this.cardsList.find((c) => c.id === defId) || null;
    },
    secondaryCards() {
      const defId = this.profile?.default_card_id;
      if (!defId) {
        return this.cardsList;
      }
      return this.cardsList.filter((c) => c.id !== defId);
    },
    selectedDefaultCardPan() {
      if (!this.selectedDefaultCard) {
        return '';
      }
      const start = String(this.selectedDefaultCard.bin).slice(0, 3);
      const middle = String(this.selectedDefaultCard.bin).slice(-2);
      return `${start} ${middle}** **** ${this.selectedDefaultCard.last_4}`;
    },
  },
}
</script>

<style lang="scss" scoped>
  .cards-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 35px;
    padding-bottom: 35px;
    box-sizing: border-box;
    background-color: var(--profile-page-bgc);
  }

  .cards-container,
  .spinner-container {
    @include base-page-container;

    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--profile-text-color);
  }

  .main-card-container,
  .secondary-card-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .main-card-container {
    margin-bottom: 30px;
  }

  .main-card-title-block,
  .secondary-card-title-block {
    width: 100%;
    max-width: 1400px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }

  .main-card-title,
  .secondary-card-title {
    font-size: 18px;
    font-weight: 600;
  }

  .add-btn {
    @include buttonWithImg;
    width: 176px;
  }

  .spinner-container {
    justify-content: center;
    margin-top: 10%;
  }

  .spinner ::v-deep {
    width: 100%;
  }

  .empty-container {
    width: 100%;
    padding: .5rem;
    box-sizing: border-box;
    background-color: rgb(255, 241, 241);
    border-radius: 5px;
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
    }

    span {
      font-size: .875rem;
      line-height: 1.25rem;
      color: rgb(173, 20, 26);
      font-weight: 600;
    }
  }

  .cards-block {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .btn-container {
    width: 300px;
    height: 65px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .modal-header {
    @include modal-close-block;
  }

  .change-default-card-modal {
    width: 480px;
    max-width: calc(95vw - 30px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
  }

  .change-default-card-modal-icon {
    width: 96px;
    height: 96px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #F2A500;
    font-weight: 700;
    font-size: 52px;
    line-height: 52px;
    color: white;
  }

  .change-default-card-modal-title {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.1px;
    color: #022131;
  }

  .change-default-card-modal-text {
    width: 440px;
    max-width: 100%;
    margin-bottom: 60px;
    font-size: 14px;
    line-height: 22px;
    color: #022131;
  }

  .change-default-card-modal-text span {
    font-weight: 600;
  }

  .change-default-card-modal-btn-container {
    width: 440px;
    max-width: 100%;
    height: 48px;
  }

  .notice-title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 22px;
    line-height: 125%;
    text-align: center;
    color: #EB5757;
  }

  .notice-text {
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 20px;
    line-height: 125%;
    text-align: center;
    color: #101010;
  }

  .modal-desc {
    width: 580px;
    max-width: 100%;
    text-align: center;
    margin-bottom: 25px;
  }

  .btns-block {
    display: flex;
    margin-bottom: 30px;
  }

  .accept-btn-block {
    width: 140px;
    height: 30px;
    margin-right: 20px;
  }

  .cancel-btn-block {
    width: 130px;
    height: 30px;
  }

  .accept-btn ::v-deep {
    border: 2px solid #41BF7B;
  }

  .cancel-btn ::v-deep {
    background-color: white;
    border: 2px solid #41BF7B;
    box-sizing: border-box;
    color: #41BF7B;

    &:hover {
      color: white;
    }
  }

  .route-name {
    @include route-name;
    width: 95%;
    text-align: start;
    margin-bottom: 40px;
    margin-top: -20px;
  }

  .amount-notice {
    margin-top: 65px;
    padding: 30px;
    box-sizing: border-box;
    width: fit-content;
    background: #F8F8F8;
    border: 1px solid #F49332;
    border-radius: 20px;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.01em;
    color: #EB5757;
    text-align: center;
  }

  @media screen and (max-width: 968px) {
    .secondary-card-title-block {
      flex-direction: column;
      gap: 25px;
    }

    .change-default-card-modal {
      min-height: auto;
      padding-top: 32px;
    }

    .change-default-card-modal-icon {
      width: 80px;
      height: 80px;
      font-size: 44px;
      line-height: 44px;
    }

    .change-default-card-modal-text {
      margin-bottom: 32px;
    }
  }
</style>